module.exports = __webpack_public_path__ + "media/native-apps/jonkoping-e933b5bf.webp";